import React from "react";
import { FaYoutube, FaFacebook, FaTelegram, FaWhatsapp, FaTiktok } from "react-icons/fa";
import { MdOutlineArrowOutward } from "react-icons/md";

function ConnectWithUs() {
  const platforms = [
    {
      name: "YouTube",
      icon: FaYoutube,
      link: "https://youtube.com/@alguidancebyjanithnawod?si=C15p9qFI_4fzUsp6",
      color: "text-red-600",
      bg: "bg-red-50",
    },
    {
      name: "Tik Tok",
      icon: FaTiktok,
      link: "https://www.tiktok.com/@alguidancebyjanithnawod?_r=1&_t=ZS-91h0VlegVIg",
      color: "text-black",
      bg: "bg-gray-50",
    },
    {
      name: "Facebook",
      icon: FaFacebook,
      link: "https://www.facebook.com/share/14QGeTebfLG/",
      color: "text-blue-600",
      bg: "bg-blue-100",
    },
  ];

  const telegramChannels = [
    {
      name: "biology කුප්පිය",
      link: "https://t.me/biologykuppiya",
    },
    {
      name: "සියලුම දැනුම්දීම්",
      link: "https://t.me/biologyjanithnawod2026",
    },
    {
      name: "Masterclass series සහභාගී වන ළමුන්ගේ අදහස්",
      link: "https://t.me/biologyfeedback",
    },
  ];

  const whatsappGroups = [
    {
      name: "Discussion Group 7",
      label : "2027 ළමුන් සඳහා",
      link: "https://chat.whatsapp.com/H88ARGKFlUq0afYSVVcyzA?s=sw&p=a&ilr=4",
    },
    {
      name: "Discussion Group 6",
      label : "2027 ළමුන් සඳහා",
      link: "https://chat.whatsapp.com/Cd2kSSYPQkL8NRCAhwm8j3?s=sw&p=a&ilr=4",
    },
    {
      name: "Discussion Group 3",
      link: "https://chat.whatsapp.com/LhhEd0dSJFE1PhcfmoU7rN",
    },
  ];

  return (
    <div className="w-full px-4 md:px-8 mt-20 mb-20">
      <div className="flex flex-col items-center mb-10">
        <h2 className="text-3xl font-semibold text-myBlack">Connect With Us</h2>
      </div>

      {/* WhatsApp + Telegram Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
        {/* Telegram Block */}
        <div>
          <div className="space-y-3">
            {telegramChannels.map((channel, index) => (
              <a
                key={index}
                href={channel.link}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center min-h-[64px] rounded-lg transition bg-[#0088CC] px-2 py-3"
              >
                <div className="flex gap-3 text-white">
                  <FaTelegram className="text-white text-3xl" />
                  {channel.name}
                </div>
              </a>
            ))}
          </div>
        </div>

        {/* WhatsApp Block */}
        <div>
          <div className="space-y-3">
            {whatsappGroups.map((channel, index) => (
              <a
                key={index}
                href={channel.link}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center min-h-[64px] rounded-lg transition bg-[#25D366] px-2 py-3"
              >
                <div className="flex gap-3 text-white">
                  <FaWhatsapp className="text-green-200 text-3xl" />
                  <div className="flex flex-col justify-center">
                    <span>{channel.name}</span>
                    {channel.label && (
                      <span className="text-xs text-green-100">{channel.label}</span>
                    )}
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* Main Platforms Card Grid */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 max-w-screen-lg mx-auto">
        {platforms.map((platform, index) => (
          <a
            key={index}
            href={platform.link}
            target="_blank"
            rel="noopener noreferrer"
            className={`flex flex-col items-center justify-between shadow-sm border p-6 rounded-md hover:bg-slate-50 transition-colors ${platform.bg}`}
          >
            <div className="flex flex-col items-center space-y-3 w-full">
              <div className={`${platform.color} text-5xl`}>
                <platform.icon />
              </div>
              <h1 className="font-semibold text-2xl text-myBlack">
                {platform.name}
              </h1>
            </div>

            <div className="flex justify-center items-center w-full mt-4">
              <button className="flex flex-row items-center space-x-2 text-sm font-bold text-gray-500">
                <span>Visit Platform</span>
                <MdOutlineArrowOutward className="text-base" />
              </button>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
}

export default ConnectWithUs;
